import { render, staticRenderFns } from "./DistributePlan.vue?vue&type=template&id=00e035d5&scoped=true"
import script from "./DistributePlan.vue?vue&type=script&lang=ts"
export * from "./DistributePlan.vue?vue&type=script&lang=ts"
import style0 from "./DistributePlan.vue?vue&type=style&index=0&id=00e035d5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e035d5",
  null
  
)

export default component.exports